var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column" },
    [
      _c(
        "div",
        {
          staticClass: "screen-mode-and-save justify-content-end detail-mode",
          class: { "screen-mode-and-save-scroll": _vm.isScroll }
        },
        [
          _c("div", { staticClass: "wrap-screen-mode justify-content-end" }, [
            _c(
              "button",
              { staticClass: "save-button", on: { click: _vm.submitForm } },
              [_vm._v("\n        Save\n      ")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-page card-page-detail" }, [
        _c("div", { staticClass: "card-page-title-multiple" }, [
          _c("div", { staticClass: "d-flex align-items-start" }, [
            _c("img", {
              staticClass: "back-icon",
              attrs: { src: require("@/assets/new-form-ui/arrow-icon.svg") }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "w-100" }, [
              _c(
                "div",
                {
                  staticClass: "title-1",
                  class: { "error-input": _vm.$v.dataSetup.text_1.$error },
                  on: {
                    click: function($event) {
                      _vm.openModalTitle("text_1")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.dataSetup.text_1 || "Field 1") +
                      "\n\n            "
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "edit-or-delete",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.openModalTitle("text_1")
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "button" }, [
                        _c(
                          "div",
                          {
                            staticClass: "edit",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                _vm.openModalTitle("text_1")
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-pencil-square-o" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "tooltip-component" }, [
                              _vm._v("Edit title")
                            ])
                          ]
                        )
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "title-2",
                  class: { "error-input": _vm.$v.dataSetup.text_2.$error },
                  on: {
                    click: function($event) {
                      _vm.openModalTitle("text_2")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.dataSetup.text_2 || "Field 2") +
                      "\n\n            "
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "edit-or-delete",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.openModalTitle("text_2")
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "button" }, [
                        _c(
                          "div",
                          {
                            staticClass: "edit",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                _vm.openModalTitle("text_2")
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-pencil-square-o" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "tooltip-component" }, [
                              _vm._v("Edit variable")
                            ])
                          ]
                        )
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "wrap-tabs" }, [
                _c(
                  "div",
                  { staticClass: "tabs" },
                  [
                    _vm._l(_vm.tabs, function(tab, index) {
                      return _c(
                        "div",
                        {
                          key: tab.id,
                          staticClass: "tab",
                          class: { active: tab.id === _vm.tabSelected.id },
                          on: {
                            click: function($event) {
                              _vm.changeTab(tab, index)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(tab.title) +
                              "\n\n                "
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "edit-or-delete" }, [
                            _c("div", { staticClass: "button" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "edit",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      _vm.openModalTab(tab, index)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-pencil-square-o"
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "delete",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      _vm.deleteTab(index)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-trash" })]
                              )
                            ])
                          ])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "add-tab",
                        on: {
                          click: function($event) {
                            _vm.openModalTab(null, null)
                          }
                        }
                      },
                      [_vm._m(0)]
                    )
                  ],
                  2
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-page-content multiple" },
          [
            _vm.isLoading ? _c("j-skeleton-component") : _vm._e(),
            _vm._v(" "),
            !_vm.isLoading &&
            _vm.tabs.length > 0 &&
            _vm.tabIndexSelected !== null
              ? _c(
                  "section",
                  {
                    staticClass: "section-field section-field-component mb-5",
                    class: {
                      "have-data":
                        _vm.tabs[_vm.tabIndexSelected].component &&
                        _vm.tabs[_vm.tabIndexSelected].component.length > 0
                    }
                  },
                  [
                    _vm.tabSelected.component.length === 0
                      ? _c("h5", [_vm._v("No component on this view")])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "draggable",
                      {
                        attrs: {
                          options: {
                            animation: 300
                          },
                          group: "fieldsLibrary"
                        },
                        on: { change: _vm.modifyData },
                        model: {
                          value: _vm.tabs[_vm.tabIndexSelected].component,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.tabs[_vm.tabIndexSelected],
                              "component",
                              $$v
                            )
                          },
                          expression: "tabs[tabIndexSelected].component"
                        }
                      },
                      _vm._l(_vm.tabs[_vm.tabIndexSelected].component, function(
                        component,
                        index
                      ) {
                        return _c(
                          "div",
                          {
                            key: component.name + "-" + index,
                            staticClass: "component-list",
                            class: {
                              selected:
                                _vm.selectedIndexComponent === index &&
                                _vm.isOpenPropertiesComp
                            }
                          },
                          [
                            component.info &&
                            JSON.parse(component.info).default_view ===
                              "table_view"
                              ? _c("dummy-table-view", {
                                  attrs: {
                                    "data-component": component,
                                    "for-detail-parent": true
                                  }
                                })
                              : component.info &&
                                JSON.parse(component.info).default_view ===
                                  "table_requester_view"
                              ? _c("dummy-table-view", {
                                  attrs: {
                                    "data-component": component,
                                    type: "requestor",
                                    "for-detail-parent": true
                                  }
                                })
                              : component.info &&
                                JSON.parse(component.info).default_view ===
                                  "table_approver_view"
                              ? _c("dummy-table-view", {
                                  attrs: {
                                    "data-component": component,
                                    type: "approver",
                                    "for-detail-parent": true
                                  }
                                })
                              : component.info &&
                                JSON.parse(component.info).default_view ===
                                  "create_view"
                              ? _c("dummy-create-detail-view", {
                                  attrs: {
                                    "data-component": component,
                                    type: "create",
                                    "for-detail-parent": true
                                  }
                                })
                              : component.info &&
                                JSON.parse(component.info).default_view ===
                                  "detail_view"
                              ? _c("dummy-create-detail-view", {
                                  attrs: {
                                    "data-component": component,
                                    type: "detail",
                                    "for-detail-parent": true
                                  }
                                })
                              : component.info &&
                                JSON.parse(component.info).default_view ===
                                  "calendar_view"
                              ? _c("dummy-calendar-view", {
                                  attrs: {
                                    "data-component": component,
                                    "for-detail-parent": true
                                  }
                                })
                              : component.info &&
                                JSON.parse(component.info).default_view ===
                                  "export_view"
                              ? _c("dummy-export-view", {
                                  attrs: {
                                    "data-component": component,
                                    "for-detail-parent": true
                                  }
                                })
                              : _c("div", {
                                  staticClass: "skeleton-component"
                                }),
                            _vm._v(" "),
                            component.info
                              ? _c("div", { staticClass: "edit-or-delete" }, [
                                  _c("div", { staticClass: "button" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "new-tab",
                                        on: {
                                          click: function($event) {
                                            _vm.onOpenNewtab(component)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-external-link"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "tooltip-component" },
                                          [_vm._v("Open new tab")]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "edit",
                                        on: {
                                          click: function($event) {
                                            _vm.openConfigurationComponent(
                                              component,
                                              index
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-pencil-square-o"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "tooltip-component" },
                                          [_vm._v("Edit component")]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "delete",
                                        on: {
                                          click: function($event) {
                                            _vm.deleteComponent(index)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", { staticClass: "fa fa-trash" }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "tooltip-component" },
                                          [_vm._v("Delete component")]
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      })
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btn-add-more",
                        on: {
                          click: function($event) {
                            _vm.openModalFieldLibrary(false)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "m__r--5",
                          attrs: {
                            src: require("@/assets/icon/add.png"),
                            height: "15",
                            width: "15"
                          }
                        }),
                        _vm._v("\n          Add Component\n        ")
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "section",
              [
                _c("h5", [_vm._v("Button")]),
                _vm._v(" "),
                _c("native-buttons", {
                  attrs: {
                    "data-buttons": _vm.nativeButtons,
                    "is-workflow": _vm.isWorkflow,
                    "is-multiple": _vm.isMultipleForm,
                    "is-dynamic-workflow": _vm.isDynamicWorkflow,
                    "is-approver-selection-by-function":
                      _vm.isApproverSelectionByFunction,
                    "is-page-screen": true,
                    "button-active": _vm.modeBtn,
                    menu: "detail"
                  },
                  on: { "select-btn": _vm.openConfigNativeButton }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-transparent card-transparent-detail m__t--15" },
        [
          _vm.formDetail.detail_view ||
          (_vm.formDetail.tabs && _vm.formDetail.tabs.length > 0)
            ? _c(
                "span",
                {
                  staticClass: "cursor-pointer",
                  staticStyle: { "font-size": "14px" },
                  on: { click: _vm.deleteView }
                },
                [
                  _c("i", { staticClass: "fa fa-trash" }),
                  _vm._v(" "),
                  _c("small", [_vm._v("Delete this view")])
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.showModalFieldLibrary
        ? _c("modal-field-library", {
            on: { "close-modal": _vm.closeModalFieldLibrary }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenModalTitle
        ? _c("modal-title-multiple-detail", {
            attrs: {
              id: _vm.idModalTitle,
              data: _vm.selectedTitle,
              options: _vm.variableOptions,
              title: _vm.selectedTypeTitle === "text_1" ? "Field 1" : "Field 2"
            },
            on: {
              "close-modal": function($event) {
                _vm.toggleModalTitle(false)
              },
              submit: _vm.submitModalTitle
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenModalTab
        ? _c("modal-setup-tab", {
            attrs: { id: _vm.idModalTab, data: _vm.selectedTab },
            on: {
              "delete-tab": _vm.deleteTab,
              "close-modal": function($event) {
                _vm.toggleModalTab(false)
              },
              submit: _vm.submitModalTab
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenPropertiesComp
        ? _c("component-configuration", {
            attrs: {
              id: _vm.idPropertiesComp,
              "field-detail": _vm.selectedComponent,
              options: _vm.variableOptions
            },
            on: {
              "submit-mode": _vm.submitComponent,
              "delete-configuration": _vm.deleteComponent,
              "close-configuration": function($event) {
                _vm.toggleConfigurationComponent(false)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenConfigNativeBtn
        ? _c("native-button-configuration", {
            attrs: {
              id: _vm.idConfigNativeBtn,
              "field-detail": _vm.selectedNativeBtn,
              "is-revision-btn": _vm.isRevisionBtn,
              "data-revision": _vm.nativeButtons.revision,
              label: _vm.labelBtn,
              mode: _vm.modeBtn
            },
            on: {
              "close-configuration": function($event) {
                _vm.toggleConfigurationNativeBtn(false)
              },
              "submit-configuration": _vm.submitNativeButton
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalScriptBeforeAfter",
          staticClass: "modal-native-action-button",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _vm.showModalScriptBeforeAfter
            ? _c("modal-script-before-after-field")
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "add-icon" }, [
      _c("i", { staticClass: "fa fa-plus" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0218bdea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0218bdea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/menu/jMultipleDetailView.vue
// module id = null
// module chunks = 